export default "<div class=\"notification-ellipsis\">\n    <span>.</span>\n    <span>.</span>\n    <span>.</span>\n</div>\n";